// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-container[data-v-1c7f79e7]{position:relative}.app-container .nuxt-container[data-v-1c7f79e7]{position:relative;height:calc(100vh - 60px)!important;padding-bottom:0;margin-left:250px;overflow-y:auto}.app-container .nuxt-container[data-v-1c7f79e7]::-webkit-scrollbar{display:none}.app-container .nuxt-container .nuxt-main[data-v-1c7f79e7]{width:100%;height:100%}.login-main[data-v-1c7f79e7]{width:100%;height:100vh}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
